import { useCallback } from 'react'

import { ExcludedReason } from '../../../models/searchForCare/SearchForCare'
import { CONTACT_CARE_TEAM_REQUEST_TYPES } from '../../common/constants/constants'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'

/**
 * Returns a function that determines the appropriate care navigator request type based on excluded treatment options.
 * For Solera customers, returns specific request types for coaching unavailability or high severity cases.
 * For other customers or when no exclusions exist, returns the default zero providers found request type.
 */
export const useGetCareNavigatorRequestType = (isCustomerSolera: boolean) => {
  const getCareNavigatorRequestType = useCallback(
    (excludedTreatmentOptionsReasons?: ExcludedReason[]) => {
      if (isCustomerSolera) {
        const coachingUnavailable = excludedTreatmentOptionsReasons
          ?.find((reason) => reason.treatmentOption === TREATMENT_OPTIONS.COACHING)
          ?.reasons.includes('coachesUnavailable')
        if (coachingUnavailable) {
          return CONTACT_CARE_TEAM_REQUEST_TYPES.SOLERA_COACHES_UNAVAILABLE
        } else {
          return CONTACT_CARE_TEAM_REQUEST_TYPES.SOLERA_HIGH_SEVERITY
        }
      } else return CONTACT_CARE_TEAM_REQUEST_TYPES.ZERO_PROVIDERS_FOUND
    },
    [isCustomerSolera],
  )

  return getCareNavigatorRequestType
}
